// src/com/trans_plan_tsr/TransPlanTsrGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * TRANS_PLAN_TSR Apollo Graphql
 * VIEW
 * Project: NewTOP for cloud
 * 2025-01-02 14:49:31 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const TRANS_PLAN_TSR_LIST_PART = gql`
fragment TransPlanTsrListPart on TransPlanTsr {
    planId
    dcCd
    arriveId
    storeId
    comId
    dcStaffName
    agentStaffName
    cargoStaffName
    cargoTel
    planDate
    planTime
    hocha
    transTypeCd
    txStage
    vehTypeId
    vehTypeName
    cargoUnit
    loadCapa
    loadCapaText
    rentType
    shprReqTime
    dptrReqTime
    arrReqTime
    dockno
    charge
    addCharge
    note
    reqStateFlag
    transFlag
    vehPlates
    driverName
    driverMobile
    bol1
    bol2
    bol3
    loadCount
    loadStTime
    loadEnTime
    prosDptrTime
    prosArrTime
    sealNo1
    sealNo2
    sealNo3
    loadStaffName
    unsoldBol
    unsoldPallet
    unsoldCount
    memo
    inputArrTime
    traceStatus
    regTypeCd
    endFlag
    zipgiBool
    inputDptrTime
    printDate
    printUser
    inputTempF
    inputTempM
    inputTempR
    aPalKpp
    aPalAju
    aRollN
    aRollJum
    aB2bKpp
    aB2bAju
    aEtc
    aTray
    tempF
    tempM
    tempR
    fFPalKpp
    fMPalKpp
    fRPalKpp
    fFPalAju
    fMPalAju
    fRPalAju
    fFShrFull
    fMShrFull
    fRShrFull
    fFShrHalf
    fMShrHalf
    fRShrHalf
    fFEtcKpp
    fMEtcKpp
    fREtcKpp
    fFEtcAju
    fMEtcAju
    fREtcAju
    fNjc
    fUcolor
    fOctagon
    fTray
    eFDolly
    eMDolly
    eRDolly
    eFDollycart
    eMDollycart
    eRDollycart
    eFRoll
    eMRoll
    eRRoll
    eFPalKpp
    eMPalKpp
    eRPalKpp
    eFPalAju
    eMPalAju
    eRPalAju
    eCigar
    eCorn
    ePulp
    eMu
    eJumDolly
    eJumDollycart
    eJumRoll
    reserve3
    aOpSpec
    aOpJum
    aOpTrunc
    aHiDanpra
    aHiRoll
    regDate
    regUser
    dcName
    dcTypeCd
    dcTypeName
    dcTransStaffName
    dcOperStaffName
    dcOfficeStaffName
    dcOfficeTelno
    dcUseYn
    comName
    comAgentName
    comOfficeTel
    vehInfoSeq
    vehId
    gpsTime
    transPosYn
    rentYn
    storeName
    storeStaffName
    storeAddr
    storeOfficeTelno
    storeSecuTelno
    transType
    reqState
    regUserName
    bulkItems {
        planId
        bulkCompanyId
        bulkProductsId
        quantity
        memo
        regDate
        regUser
        updatedDate
        updatedUser
        comName
        prodName
    }
    bindStores {
        bindGroupNo
        planId
        bindOrderNo
        storeId
        storeName
        dptrReqTime
        timeArrival
        arrived
        regUser
        regDate
        planDate
        vehInfoSeq
        vehPlates
        dcCd
        hocha
        useYn
    }
}
`;

//transPlanTsrList(planDate:String!,dcCd:String!,storeId:String!): [TransPlanTsr]!
export const LIST_TRANS_PLAN_TSR = gql`
${TRANS_PLAN_TSR_LIST_PART}
query ListTransPlanTsr($planDate: String!, $dcCd: String!, $storeId: String!) {
    transPlanTsrList(planDate: $planDate, dcCd: $dcCd, storeId: $storeId) {
        ...TransPlanTsrListPart
    }
}
`;

// transPlanTsrItem(planId: String!): TransPlanTsr
export const GET_TRANS_PLAN_TSR = gql`
${TRANS_PLAN_TSR_LIST_PART}
query GetTransPlanTsr($planId: String!) {
    transPlanTsrItem(planId: $planId) {
        ...TransPlanTsrListPart
    }
}
`;

// transPlanTsrSave(transPlanTsr: TransPlanTsrInput!): CommonResponse
export const SAVE_TRANS_PLAN_TSR = gql`
mutation SaveTransPlanTsr($transPlanTsr:InputTransPlanTsrEdit!) {
	transPlanTsrSave(transPlanTsr: $transPlanTsr) {
		ok
		message
	}
}
`;

// transPlanTsrIssue(planId: String!): CommonResponse
export const ISSUE_TRANS_PLAN_TSR = gql`
mutation IssueTransPlanTsr($planId: String!) {
    transPlanTsrIssue(planId: $planId) {
        ok
        message
    }
}
`;
